// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nounExplanation{width:300px;padding:5px;border:1px solid #5cadff;border-radius:3px;color:#808695;font-weight:400;position:fixed;top:280px;left:50px;background-color:#ffefd5;z-index:999}", ""]);
// Exports
module.exports = exports;
